import { render, staticRenderFns } from "./Ordres.vue?vue&type=template&id=75bbb777&"
import script from "./Ordres.vue?vue&type=script&lang=js&"
export * from "./Ordres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports